import { Injectable, RendererFactory2 } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {

    private renderer: any;

    constructor(
        private rendererFactory: RendererFactory2
    ) { }

    canActivate() {
        this.removePreloader();
        return true
    }

    removePreloader() {
        this.renderer = this.rendererFactory.createRenderer(null, null);
        let loader = this.renderer.selectRootElement('#preRenderLoader');
        this.renderer.setStyle(loader, 'display', 'none');;
    }
}
